import React, { useEffect, useState } from "react";
import {
	Alert,
	Button,
	CircularProgress,
	Grid,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link as RouterLink } from "react-router-dom";

import { SubHeader } from "../../../utils/componentes-utiles/SubHeader";
import { PermisosOpciones } from "./PermisosOpciones";
import {
	actualizarPermisosDocumentacion,
	getPermisosDocumentacion,
} from "../../../services/apis";

export const PermisosDocumentacion = () => {
	const [roles, setRoles] = useState([]);
	const [opciones, setOpciones] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");


	const cargarPermisos = async () => {
		setLoading(true);
		setError("");

		try {
			const response = await getPermisosDocumentacion();

			if (response?.success === true) {
				setRoles(Array.isArray(response?.data?.roles) ? response.data.roles : []);
				setOpciones(Array.isArray(response?.data?.opciones) ? response.data.opciones : []);
				return;
			}

			setRoles([]);
			setOpciones([]);
			setError(response?.message || "No se pudieron cargar los permisos.");
		} catch (loadError) {
			console.error("Error cargando permisos de documentacion:", loadError);
			setRoles([]);
			setOpciones([]);
			setError(
				loadError?.response?.data?.message ||
					"No se pudieron cargar los permisos de documentacion."
			);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		void cargarPermisos();
	}, []);

	const guardarPermisos = async (updatedOpciones) => {
		const response = await actualizarPermisosDocumentacion(updatedOpciones);

		if (response?.success !== true) {
			throw new Error(
				response?.message || "No se pudieron guardar los permisos de documentacion."
			);
		}
	};

	return (
		<Grid container justifyContent="center" size={{ xs: 12 }}>
			<SubHeader titulo="Permisos de documentacion" />

			<Grid container size={{ xs: 10 }} sx={{ mb: 2 }}>
				<Button
					variant="text"
					startIcon={<ArrowBackIcon />}
					component={RouterLink}
					to="/admin"
				>
					Volver a administracion
				</Button>
			</Grid>

			<Grid container size={{ xs: 10 }} sx={{ mb: 2 }}>
				<Alert severity="info" sx={{ width: "100%" }}>
					Estos permisos controlan tanto la visibilidad del modulo de documentacion
					como el acceso real a sus endpoints en backend.
				</Alert>
			</Grid>

			{loading && <CircularProgress />}

			{!loading && error && (
				<Grid container size={{ xs: 10 }}>
					<Alert
						severity="error"
						action={
							<Button color="inherit" size="small" onClick={cargarPermisos}>
								Reintentar
							</Button>
						}
						sx={{ width: "100%" }}
					>
						{error}
					</Alert>
				</Grid>
			)}

			{!loading && !error && opciones.length === 0 && (
				<Grid container size={{ xs: 10 }}>
					<Alert severity="warning" sx={{ width: "100%" }}>
						No hay opciones de documentacion configuradas en `opciones_documentacion`.
					</Alert>
				</Grid>
			)}

			{!loading && !error && opciones.length > 0 && (
				<Grid container justifyContent="center" size={{ xs: 12 }}>
					<PermisosOpciones
						roles={roles}
						opciones={opciones}
						title="Opciones de documentacion"
						nombreArray="opciones_documentacion"
						descripcion="Asigna que roles pueden acceder a personas, documentos y cualquier otra opcion del modulo."
						index={0}
						onUpdatePermissions={guardarPermisos}
					/>
				</Grid>
			)}
		</Grid>
	);
};
